import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_cns - CNS do profissional
 */
export async function getCadastrosIndividuais(cod_ibge, nu_cns) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/indicador-imunizacao/detalhado/' + cod_ibge + '/' + nu_cns
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da equipe
 * @param {int} micro_area - Micro área do profissional
 */
export async function getCadastrosIndividuaisPorMicroArea(
  cod_ibge,
  nu_ine,
  micro_area
) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/indicador-imunizacao/detalhado/microarea/' +
        cod_ibge +
        '/' +
        nu_ine +
        '/' +
        micro_area
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais sem ACS de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisSemAcs(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/indicador-imunizacao/detalhado/sem-acs/' + cod_ibge + '/' + nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais sem equipe
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getCadastrosIndividuaisSemEquipe(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/indicador-imunizacao/detalhado/sem-equipe/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais todos de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisTodosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/indicador-imunizacao/detalhado/todos/equipe/' +
        cod_ibge +
        '/' +
        nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor de acordo com o valor
/**
 *
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor < 95) {
    return 'red'
  } else {
    return 'green'
  }
}

export function formatarCadastros(cadastros, vacinasRegistradas) {
  const data = cadastros.map((item, index) => {
    // Hexa
    const dosesHexa = vacinasRegistradas.filter((element) => {
      return (
        item.cfcp !== null &&
        element.cfcp == item.cfcp &&
        element.id_imuno == '43'
      )
    })
    const coresHexa = [
      {
        dose: '1ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: '2ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: '3ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
    ]
    const primeiraDoseHexa = dosesHexa.find((el) => el.id_dose_imuno === '1')
    const segundaDoseHexa = dosesHexa.find((el) => el.id_dose_imuno === '2')
    const terceiraDoseHexa = dosesHexa.find((el) => el.id_dose_imuno === '3')

    if (primeiraDoseHexa !== undefined) {
      coresHexa[0].cor = 'green'
      coresHexa[0].dt_aplicacao_br = primeiraDoseHexa.dt_aplicacao_br
    }
    if (segundaDoseHexa !== undefined) {
      coresHexa[1].cor = 'green'
      coresHexa[1].dt_aplicacao_br = segundaDoseHexa.dt_aplicacao_br
    }
    if (terceiraDoseHexa !== undefined) {
      coresHexa[2].cor = 'green'
      coresHexa[2].dt_aplicacao_br = terceiraDoseHexa.dt_aplicacao_br
    }

    // Penta valente
    const dosesPentaValente = vacinasRegistradas.filter((element) => {
      return (
        item.cfcp !== null &&
        element.cfcp == item.cfcp &&
        element.id_imuno == '42'
      )
    })

    const coresPentaValente = [
      {
        dose: '1ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: '2ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: '3ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
    ]
    const primeiraDosePenta = dosesPentaValente.find(
      (el) => el.id_dose_imuno === '1'
    )
    const segundaDosePenta = dosesPentaValente.find(
      (el) => el.id_dose_imuno === '2'
    )
    const terceiraDosePenta = dosesPentaValente.find(
      (el) => el.id_dose_imuno === '3'
    )
    if (primeiraDosePenta !== undefined) {
      coresPentaValente[0].cor = 'green'
      coresPentaValente[0].dt_aplicacao_br = primeiraDosePenta.dt_aplicacao_br
    } else {
      if (Number(item.idade_meses) >= 2 && primeiraDoseHexa === undefined) {
        coresPentaValente[0].cor = 'red'
      }
    }

    if (segundaDosePenta !== undefined) {
      coresPentaValente[1].cor = 'green'
      coresPentaValente[1].dt_aplicacao_br =
        segundaDosePenta != undefined ? segundaDosePenta.dt_aplicacao_br : ''
    } else {
      if (
        Number(item.idade_meses) >= 4 &&
        segundaDoseHexa === undefined &&
        primeiraDosePenta !== undefined &&
        utils.methods.diffDays(primeiraDosePenta.dt_aplicacao) > 60
      ) {
        coresPentaValente[1].cor = 'red'
      }
    }

    if (terceiraDosePenta !== undefined) {
      coresPentaValente[2].cor = 'green'
      coresPentaValente[2].dt_aplicacao_br = terceiraDosePenta.dt_aplicacao_br
    } else {
      if (terceiraDoseHexa !== undefined) {
        coresPentaValente[2].cor = 'white'
      } else {
        if (
          (Number(item.idade_meses) >= 8 && terceiraDoseHexa === undefined) ||
          (segundaDosePenta !== undefined &&
            utils.methods.diffDays(segundaDosePenta.dt_aplicacao) > 60)
        ) {
          coresPentaValente[2].cor = 'red'
        }
      }
    }

    // Vip
    const dosesVip = vacinasRegistradas.filter((element) => {
      return (
        item.cfcp !== null &&
        element.cfcp == item.cfcp &&
        element.id_imuno == '22'
      )
    })
    const coresVip = [
      {
        dose: '1ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: '2ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: '3ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
    ]
    const primeiraDoseVip = dosesVip.find((el) => el.id_dose_imuno === '1')
    const segundaDoseVip = dosesVip.find((el) => el.id_dose_imuno === '2')
    const terceiraDoseVip = dosesVip.find((el) => el.id_dose_imuno === '3')

    if (primeiraDoseVip !== undefined) {
      coresVip[0].cor = 'green'
      coresVip[0].dt_aplicacao_br = primeiraDoseVip.dt_aplicacao_br
    } else {
      if (Number(item.idade_meses) >= 2 && primeiraDoseHexa === undefined) {
        coresVip[0].cor = 'red'
      }
    }

    if (segundaDoseVip !== undefined) {
      coresVip[1].cor = 'green'
      coresVip[1].dt_aplicacao_br =
        segundaDoseVip != undefined ? segundaDoseVip.dt_aplicacao_br : ''
    } else {
      if (
        Number(item.idade_meses) >= 4 &&
        segundaDoseHexa === undefined &&
        primeiraDoseVip !== undefined &&
        utils.methods.diffDays(primeiraDoseVip.dt_aplicacao) > 60
      ) {
        coresVip[1].cor = 'red'
      }
    }

    if (terceiraDoseVip !== undefined) {
      coresVip[2].cor = 'green'
      coresVip[2].dt_aplicacao_br = terceiraDoseVip.dt_aplicacao_br
    } else {
      if (terceiraDoseHexa !== undefined) {
        coresVip[2].cor = 'white'
      } else {
        if (
          (Number(item.idade_meses) >= 8 && terceiraDoseHexa === undefined) ||
          (segundaDoseVip !== undefined &&
            utils.methods.diffDays(segundaDoseVip.dt_aplicacao) > 60)
        ) {
          coresVip[2].cor = 'red'
        }
      }
    }

    return {
      id: index,
      ...item,
      coresPentaValente,
      coresVip,
      coresHexa,
    }
  })

  return data
}

export function exibirVermelhos(cadastros, vacinasRegistradas) {
  const cadastrosFormatados = formatarCadastros(cadastros, vacinasRegistradas)
  let filtro = cadastrosFormatados.filter((item) => {
    if (
      item.coresPentaValente.find((element) => element.cor === 'red') ||
      item.coresVip.find((element) => element.cor === 'red') ||
      item.coresHexa.find((element) => element.cor === 'red')
    ) {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros, vacinasRegistradas) {
  const cadastrosFormatados = formatarCadastros(cadastros, vacinasRegistradas)
  let filtro = cadastrosFormatados.filter((item) => {
    if (
      item.coresPentaValente.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresVip.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresHexa.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      )
    ) {
      return true
    }
  })
  return filtro
}

export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  nomeProfissional,
  data_secretaria_de_saude,
  vacinasRegistradas
) {
  const cadastrosFormatados = formatarCadastros(cadastros, vacinasRegistradas)
  let title_pdf = 'Vacinas Pólio e Penta'
  let titlePdfSave = utils.methods.titlePdf(
    'Vacinas Pólio e Penta',
    selectEquipe.no_equipe
  )
  let description_pdf = 'Crianças menores de até 1 ano'
  let headers_pdf = ['']
  var data_pdf = []
  for (let i = 0; i < cadastrosFormatados.length; i++) {
    var obj = {}
    let template = ''
    template = `${
      cadastrosFormatados[i].nu_cpf != null && cadastrosFormatados[i].nu_cpf != undefined
        ?  ' CPF:' + cadastrosFormatados[i].nu_cpf + '\n'
        : ''
    }${
      cadastrosFormatados[i].nu_cns != null && cadastrosFormatados[i].nu_cns != undefined
        ? ' CNS:' + cadastrosFormatados[i].nu_cns + '\n'
        : ''
    } Nome: ${cadastrosFormatados[i].no_cidadao} \n Nascimento: ${
      utils.methods.formatDate(cadastrosFormatados[i].dt_nascimento) +
      '  (' +
      cadastrosFormatados[i].idade_meses +
      ' meses)'
    } \n Mãe: ${cadastrosFormatados[i].no_mae} \n Microárea do ACS: ${
      cadastrosFormatados[i].micro_area != null
        ? cadastrosFormatados[i].micro_area
        : ''
    } \n`
    template += ' Pentavalente: '
    cadastrosFormatados[i].coresPentaValente.forEach((el) => {
      template += `${el.dose} - ${el.dt_aplicacao_br} | `
    })
    template += '\n'

    template += ' VIP: '
    cadastrosFormatados[i].coresVip.forEach((el) => {
      template += `${el.dose} - ${el.dt_aplicacao_br} | `
    })
    template += '\n'

    template += ' Hexavalente: '
    cadastrosFormatados[i].coresHexa.forEach((el) => {
      template += `${el.dose} - ${el.dt_aplicacao_br} | `
    })
    template += '\n'
    obj.template = template
    obj.coresPentaValente = cadastrosFormatados[i].coresPentaValente
    obj.coresVip = cadastrosFormatados[i].coresVip
    obj.coresHexa = cadastrosFormatados[i].coresHexa
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'left',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          } else {
            let color = 'green'

            data.row.raw[1].forEach((element) => {
              if (element.cor === 'red') {
                color = 'red'
              }
            })

            data.row.raw[2].forEach((element) => {
              if (element.cor === 'red') {
                color = 'red'
              }
            })

            data.row.raw[3].forEach((element) => {
              if (element.cor === 'red') {
                color = 'red'
              }
            })

            if (color === 'red') {
              doc.setTextColor(194, 10, 16)
            } else {
              doc.setTextColor(2, 99, 57)
            }
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export async function carregarSerieHistoricaPorEquipe(cod_ibge, nu_ine, xaxis) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/equipe/' + cod_ibge + '/' + nu_ine + '/5'
    )
    let array_chart_equipe = []
    for (let i = 0; i < xaxis.length; i++) {
      var eixo_x_atual = xaxis[i]
      for (const item of response.data) {
        var resultado = 0
        if (item.mes_ano == eixo_x_atual) {
          resultado = item.resultado
          break
        } else {
          resultado = null
        }
      }
      array_chart_equipe.push(resultado)
    }
    return array_chart_equipe
  } catch (err) {
    console.log(err)
  }
}
export async function carregarSerieHistoricaPorAcs(
  cod_ibge,
  profissional,
  xaxis
) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/acs/' + cod_ibge + '/' + profissional + '/5'
    )

    let array_chart_acs = []
    if (response.data.length !== 0) {
      for (let i = 0; i < xaxis.length; i++) {
        var eixo_x_atual = xaxis[i]
        for (const item of response.data) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            resultado = item.resultado
            break
          } else {
            resultado = null
          }
        }
        array_chart_acs.push(resultado)
      }
      return array_chart_acs
    } else {
      return null
    }
  } catch (err) {
    console.log(err)
  }
}
